module.exports = __webpack_public_path__ + "static/media/Diamond.abc55d2e.svg";